import { Injectable, EventEmitter } from '@angular/core';
import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';
import { INotifier } from '../dataModels/contracts/INotifier';

@Injectable()
export class NotifierProviderService implements INotifier {

    public onOkButtonVisibilityChnage: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onDismissButtonVisibilityChnage: EventEmitter<boolean> = new EventEmitter<boolean>();
    public OnNotify: EventEmitter<string> = new EventEmitter<string>();
    
    setOkButtonVisibility(visibility: boolean) {
        this.onOkButtonVisibilityChnage.emit(visibility);
    }
    setDismissVisibility(visibility: boolean) {
        this.onDismissButtonVisibilityChnage.emit(visibility);
    }

    public notify(message: string, options?: any) {
        this.OnNotify.emit(message);
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/providers/notifier-provider.service.ts